import {autoinject, transient, useView} from "aurelia-framework";
import { CompanyService } from "../../../../../../services/modules/company-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { GetDocPerformance } from "../../../../../../models/vessels/vessel.models";
import * as Enumerable from "linq";
import { CompanyModel } from "../../../../../../models/companies/company.models";
import { Router } from "aurelia-router";
import { RightShipQiRouterConstants } from "../../../../../../configuration/rightshipqi-router.constants";

@autoinject
@transient()
@useView('views/pages/modules/company/steps/doc-performance-step/doc-performance-step.html')
export class DocPerformanceStep {

    isLoading: boolean = false;
    result: GetDocPerformance;
    maxIncPercentage: number = 100;
    maxIncidentCount: number = 1;
    maxPscDeficienciesAverage: number = 1;
    maxPscDetentionsPercentage: number = 100;

    constructor(private companyService: CompanyService, private notificationService: NotificationClientService, private router: Router) {
    }

    activate(model: CompanyModel) {
        const extra = 1;
        this.isLoading = true;
        this.companyService.getDocPerformance(model.companyId)
            .then(result => {
                this.isLoading = false;
                this.result = result;
                if (this.result && this.result.docPerformanceIncidentDetails) {
                    const incDetEnumerable = Enumerable.from(this.result.docPerformanceIncidentDetails);
                    this.maxIncidentCount = Math.max((incDetEnumerable.any()?incDetEnumerable.max(x => x.incidentCount) : 1), extra);
                }
                if (this.result && this.result.docPerformanceIncidents) {
                    const incEnumerable = Enumerable.from(this.result.docPerformanceIncidents);
                    this.maxIncPercentage = Math.max((incEnumerable.any()?incEnumerable.max(x => x.vesselsWithIncidentPercentage) : 1), extra);
                }
                
                if (this.result && this.result.docPerformancePscs) {
                    const pscEnumerable = Enumerable.from(this.result.docPerformancePscs);
                    this.maxPscDeficienciesAverage = Math.max((pscEnumerable.any()?pscEnumerable.max(x => x.averageDeficiencies) : 0), extra);
                    this.maxPscDetentionsPercentage = Math.max((pscEnumerable.any()?pscEnumerable.max(x => x.detentionsPercentage) : 1), extra);
                }
            }).catch(() => {
                this.isLoading = false;
                this.notificationService.show("Error", "Error loading DOC Performance data", NotificationType.Error);
            });
    }
    
    public vesselUrl(id: any) {
        return this.router.generate(RightShipQiRouterConstants.RouteNames.VesselDetails, {
            id: id,
        });
    }
}